module.exports = __webpack_public_path__ + "static/img/Brave.722cc31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Brave.jpg
// module id = kknD
// module chunks = 1